import { ToastAlertTypes } from '@genial/components';
import { IToggle } from '@unleash/proxy-client-react';
import { v4 as uuid } from 'uuid';

import { SuitabilityCustomPropsMap } from '../../store/customer/functions';
import { AssetSelectedTypeMap } from '../../store/product/types';
import { FeatureToggle } from '../../utils/useUnleashFlags';

export type SuitabilityPropertiesGetterMap = {
  [K in keyof AssetSelectedTypeMap]: (
    offer: AssetSelectedTypeMap[K]
  ) => SuitabilityCustomPropsMap[K];
};

export const suitabilityPropertiesMap: Partial<SuitabilityPropertiesGetterMap> = {
  fixedIncome: (offer) => ({
    amount: offer.orderValue,
    feeId: String(offer.orderFee?.feeId ?? offer.feeId),
    correlationId: uuid(),
  }),
  funds: (offer) => ({
    productId: offer.productId,
    amount: offer.orderValue,
    correlationId: uuid(),
  }),
  directTreasury: (offer) => ({
    productId: offer.productId,
    assetName: offer.productNameNormalized,
    amount: offer.orderValue,
    correlationId: uuid(),
  }),
  equity: (offer) => ({
    productId: offer.productIdNormalized,
    assetName: offer.productNameNormalized,
    amount: offer.orderValue * (offer.orderQuantity ?? 1),
    correlationId: uuid(),
  }),
  coes: (offer) => ({
    productId: offer.productId,
    amount: offer.orderValue,
    assetName: offer.productNameNormalized,
    correlationId: uuid(),
  }),
};

export const defaultSuitabilityErrorMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Erro ao verificar risco da carteira do cliente.',
  'Ocorreu um erro ao verificar o risco da carteira do cliente,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];

export const skipValidationFlagPerProduct: Partial<
  Record<keyof AssetSelectedTypeMap, FeatureToggle>
> = {
  equity: FeatureToggle.SkipSuitabilityCheckForEquity,
  equitySell: FeatureToggle.SkipSuitabilityCheckForEquity,
};

export const shouldSkipValidation = (
  productType: keyof AssetSelectedTypeMap,
  flags: IToggle[]
): boolean => {
  const skipFlag = skipValidationFlagPerProduct[productType];
  if (!skipFlag) {
    return false;
  }

  const shouldSkip = flags.some((flag) => flag.name === skipFlag && flag.enabled);

  return shouldSkip;
};
